import { render, staticRenderFns } from "./TaskThreadForm.vue?vue&type=template&id=6d64af26&"
import script from "./TaskThreadForm.vue?vue&type=script&lang=ts&"
export * from "./TaskThreadForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports